import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-lg border border-amber-200 bg-amber-50 p-4"
}
const _hoisted_2 = { class: "flex gap-3" }
const _hoisted_3 = { class: "text-sm text-amber-900" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_6 = { class: "mt-4 flex flex-wrap items-center justify-between gap-3" }
const _hoisted_7 = { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }
const _hoisted_8 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_9 = { class: "mt-4 divide-y divide-gray-100 rounded-lg border border-gray-200" }
const _hoisted_10 = { class: "text-gray-900" }
const _hoisted_11 = {
  key: 0,
  class: "ml-2 text-gray-500"
}
const _hoisted_12 = { class: "mt-4 flex flex-wrap gap-4 text-xs text-gray-600" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ExclamationIcon, CheckCircleIcon } from '@heroicons/vue/solid';

import { MetaConnectionStatusResult } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppAssetStatusPanel',
  props: {
    connection: {}
  },
  emits: ["confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { t } = useI18n();

const needsConfirmation = computed(() =>
    ['awaiting_confirmation', 'pending'].includes(props.connection.status || ''),
);
const hasRegisteredPhone = computed(() =>
    props.connection.phoneNumbers.some(
        (phone) => phone.isActive && phone.registrationStatus === 'REGISTERED',
    ),
);

return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_ctx.connection.status)
    ? (_openBlock(), _createBlock(_component_UiPanel, {
        key: 0,
        class: "mt-6"
      }, {
        default: _withCtx(() => [
          (needsConfirmation.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(ExclamationIcon), { class: "h-5 w-5 flex-none text-amber-700" }),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('whatsappMeta.assetStatus.confirmationNotice')), 1),
                    (_ctx.connection.hasOtherSubscribedApps)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(t)('whatsappMeta.assetStatus.otherAppsSubscribed')), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)('whatsappMeta.assetStatus.connectedWaba')), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.connection.displayName || _ctx.connection.wabaId), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["rounded-full px-3 py-1 text-xs font-medium", 
                    needsConfirmation.value
                        ? 'bg-amber-100 text-amber-800'
                        : hasRegisteredPhone.value
                          ? 'bg-emerald-100 text-emerald-800'
                          : 'bg-amber-100 text-amber-800'
                ])
            }, _toDisplayString(needsConfirmation.value
                        ? _unref(t)('whatsappMeta.assetStatus.status.awaitingConfirmation')
                        : hasRegisteredPhone.value
                          ? _unref(t)('whatsappMeta.assetStatus.status.connected')
                          : _unref(t)('whatsappMeta.assetStatus.status.ready')), 3)
          ]),
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.connection.phoneNumbers, (phone) => {
              return (_openBlock(), _createElementBlock("li", {
                key: phone.phoneNumberId || phone.displayPhoneNumber,
                class: "flex items-center justify-between gap-3 px-4 py-3 text-sm"
              }, [
                _createElementVNode("span", null, [
                  _createElementVNode("strong", _hoisted_10, _toDisplayString(phone.displayPhoneNumber || _unref(t)('whatsappMeta.assetStatus.whatsappNumber')), 1),
                  (phone.verifiedName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(phone.verifiedName), 1))
                    : _createCommentVNode("", true)
                ]),
                (phone.isActive && phone.registrationStatus === 'REGISTERED')
                  ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                      key: 0,
                      class: "h-5 w-5 text-emerald-600",
                      "aria-label": _unref(t)('whatsappMeta.assetStatus.status.active')
                    }, null, 8, ["aria-label"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('whatsappMeta.assetStatus.systemUser')) + " " + _toDisplayString(_ctx.connection.systemUserAssigned
                        ? _unref(t)('whatsappMeta.assetStatus.configured')
                        : _unref(t)('whatsappMeta.assetStatus.pending')), 1),
            _createElementVNode("span", null, "Webhook: " + _toDisplayString(_ctx.connection.webhookSubscribed
                        ? _unref(t)('whatsappMeta.assetStatus.configured')
                        : _unref(t)('whatsappMeta.assetStatus.pending')), 1)
          ]),
          (needsConfirmation.value && _ctx.connection.connectionId)
            ? (_openBlock(), _createBlock(_component_UiButton, {
                key: 1,
                variant: "primary",
                "text-variant": "white",
                class: "mt-5",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('confirm', _ctx.connection.connectionId)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('whatsappMeta.assetStatus.confirm')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})